<div class="card-wrapper">
  <div class="card__title-header">
    <div class="card__title">{{ card.label }}</div>
    <div class="card__step">{{ card.stepProgress }}</div>
  </div>

  <div class="card__description">
    <p class="card-text" [innerHTML]="card.description" [attr.data-qa]="'description'"></p>
    @if (images && images[0] && images[0].type) {
      <div>
        <div class="icon-speech-wrapper">
          @switch (images[0].type) {
            @case (imageAssetType.ICON) {
              <div>
                <i (click)="clickFile()" [class]="'material-icons ' + images[0].size">
                  {{ images[0].getSrc() }}
                </i>
                <span class="speech-bubble">{{ i18ns.clickHere }}</span>
              </div>
            }
            @case (imageAssetType.S3) {
              <img class="asset-image" [src]="images[0].getSrc()" />
            }
            @case (imageAssetType.S3_FORM) {
              <img class="asset-image" [src]="images[0].getSrc()" />
            }
            @case (imageAssetType.LOCAL) {
              <img class="section-image" [src]="images[0].getSrc()" />
            }
          }
        </div>
      </div>
    }

    <input class="imageCapture" type="file" (change)="setFromImage($event)" accept="image/*" />

    <ngx-spinner bdColor="rgba(51, 51, 51, 0.8)" size="large" type="line-scale" [attr.data-qa]="'spinner'">
    </ngx-spinner>
  </div>
</div>
<div class="form-wrapper">
  @if (form) {
    <form [formGroup]="form">
      <crds-questions [form]="form" [card]="card" [i18ns]="i18ns" [deviceContext]="deviceContext"></crds-questions>
    </form>
  }
  @if (uploadError) {
    <question-form-error
      [message]="uploadError"
      [i18ns]="i18ns"
      class="file-upload-error"
    ></question-form-error>
  }
</div>
